import { render, staticRenderFns } from "./TestNames.vue?vue&type=template&id=69636178&scoped=true"
import script from "./TestNames.vue?vue&type=script&lang=js"
export * from "./TestNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69636178",
  null
  
)

export default component.exports